import { PaymentProvider, PaymentProviderId } from '../types';
import { FlexPayProvider } from './flexpay.provider';
import { MpesaProvider } from './mpesa.provider';
import { OrangeMoneyProvider } from './orange.provider';
import { MockProvider } from './mock.provider';

/**
 * ─── Registre des providers ──────────────────────────────────────────────────
 *
 * Point unique d'enregistrement. Ajouter un fournisseur = créer sa classe
 * (implémentant PaymentProvider) et l'enregistrer ici — rien d'autre à
 * modifier dans l'application (Open/Closed).
 */

const providers = new Map<PaymentProviderId, PaymentProvider>();

export function registerProvider(provider: PaymentProvider): void {
  providers.set(provider.id, provider);
}

export function getProvider(id: PaymentProviderId): PaymentProvider {
  const provider = providers.get(id);
  if (!provider) {
    throw new Error(`PaymentProvider inconnu ou non enregistré : ${id}`);
  }
  return provider;
}

export function getAllProviders(): PaymentProvider[] {
  return [...providers.values()];
}

// Enregistrement des providers connus.
registerProvider(new FlexPayProvider());
registerProvider(new MpesaProvider());
registerProvider(new OrangeMoneyProvider());
registerProvider(new MockProvider());
